(async () => {
    const {
      updateURLParams,
      historyPush,
      parseHTML,
      getParentSection
    } = await import(window.theme.modules.utils);
    
    const isEqual = (arr1, arr2) => arr1.length === arr2.length && arr1.every((value,index) => value === arr2[index]);
    const strEsc = (str) => str.replace(/["\\]/g, '\\$&');
    const parseJSON = (el) => JSON.parse(el.textContent)
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('product-variant-selector', class extends baseComponent.default {
      elements = {
        variantsJSON: '[data-variants-json]',
        optionsJSON: '[data-options-with-values]'
      };
      
      render() {
        this.cache = {};
        this.isProductPage = this.hasAttribute('product-page');
        this.variantsData = parseJSON(this.$variantsJSON);
        this.optionsData = parseJSON(this.$optionsJSON);
        this._getDefaultVariant();
        this._checkUnavailable();
        this.addEventListener('change', this._variantChangeHandler.bind(this));
        this.on('qtyStatusUpdate', (e, data) => {
          if(data.variantId && data.html?.documentElement)this.cache[+data.variantId] = {html:data.html.documentElement.outerHTML,at:Date.now()};
        }, false)
        this._setInititalCache();
        this._initFreshRoseColors();
      };
  

      _initFreshRoseColors() {
        const handle=this.getAttribute('product-url').split('/').pop().split('?')[0];
        if(handle==='la-vie-en-roses-basket'){this._initLaVieRoseColors();return;}
        const limits={'2-dozens-of-fresh-roses':1,'50-fresh-roses':2,'75-fresh-roses':3,'100-fresh-roses':4,'love-is-in-the-air-box':4,'madames-flower-garden':2,'fresh-roses-heart':2,'drunk-in-love-rose-heart-box':2,'my-roses-tote-fresh-roses':1,'100-fresh-roses-hand-tied-bouquet':4,'coeur-de-fleur-fresh-rose-heart-box':2,'roses-lilies-hatbox-fresh-flowers':1};
        const max=limits[handle];
        if(!max || this.optionsData.length!==1 || this.querySelector('[data-fresh-colors]'))return;
        const native=this.querySelector('product-option-picker');
        const form=this.getParentSection()?.querySelector('product-form form');
        if(!native || !form)return;
        const colors={Red:'#ad1530',White:'#f7f3e9',Pink:'#e9a4b8',Lavender:'#b7a3cf',Yellow:'#f5cf49',Orange:'#ef8c35'};
        const variants=this.variantsData.filter(v=>colors[v.options[0]]);
        if(!variants.length)return;
        let selected=this.variant?.available && colors[this.variant.options[0]]?[this.variant.options[0]]:[];
        const box=document.createElement('fieldset');box.dataset.freshColors='';box.className='mdf-fresh-colors';
        const legend=document.createElement('legend');legend.textContent=handle==='100-fresh-roses-hand-tied-bouquet'?'Choose up to 4 colors':handle==='coeur-de-fleur-fresh-rose-heart-box'?'Choose up to 2 colors':handle==='roses-lilies-hatbox-fresh-flowers'?'Choose 1 color':max===1?'Choose 1 Rose Color:':'Choose up to '+max+' Rose Colors:';box.appendChild(legend);
        const choices=document.createElement('div');choices.className='mdf-fresh-color-choices';box.appendChild(choices);
        const status=document.createElement('p');status.className='mdf-fresh-color-status';status.setAttribute('aria-live','polite');box.appendChild(status);
        const property=document.createElement('input');property.type='hidden';property.name='properties[Rose Colors]';property.dataset.freshColorProperty='';form.querySelector('[data-fresh-color-property]')?.remove();form.appendChild(property);
        const buttons=[];
        const refresh=(message)=>{
          property.value=selected.join(', ');property.disabled=!selected.length;
          buttons.forEach(button=>{const on=selected.includes(button.dataset.color);button.setAttribute('aria-pressed',String(on));});
          status.textContent=message || (selected.length?'':'Please choose a rose color.');
          status.hidden=!status.textContent;
        };
        const syncPrimary=()=>{
          const name=selected[0];if(!name)return;
          const input=Array.from(native.querySelectorAll('input,select')).find(el=>el.name===this.optionsData[0].name && (el.tagName==='SELECT'||el.value===name));
          if(input){if(input.tagName==='SELECT')input.value=name;else input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}
        };
        for(const name of Object.keys(colors)){
          const variant=variants.find(v=>v.options[0]===name);if(!variant)continue;
          const button=document.createElement('button');button.type='button';button.dataset.color=name;button.disabled=!variant.available;
          button.setAttribute('aria-label',name+(variant.available?'':' — Sold out'));
          const dot=document.createElement('span');dot.className='mdf-fresh-color-dot';dot.style.backgroundColor=colors[name];dot.setAttribute('aria-hidden','true');
          const label=document.createElement('span');label.textContent=name;
          button.append(dot,label);
          if(!variant.available){const sold=document.createElement('small');sold.textContent='Sold out';button.appendChild(sold);}
          button.addEventListener('click',()=>{
            const old=selected[0];
            if(max===1)selected=[name];
            else if(selected.includes(name))selected=selected.filter(v=>v!==name);
            else if(selected.length<max)selected.push(name);
            else {refresh('Choose up to '+max+' colors. Deselect one to change your palette.');return;}
            refresh();if(old!==selected[0])syncPrimary();
          });buttons.push(button);choices.appendChild(button);
        }
        const style=document.createElement('style');style.textContent='.mdf-fresh-colors{border:0;padding:0;margin:0 0 20px;min-width:0;width:100%;text-align:center}.mdf-fresh-colors legend{width:100%;text-align:center;font-family:inherit;font-weight:700;font-size:15px;line-height:1.4;color:#27231e;margin-bottom:12px;padding:0}.mdf-fresh-color-choices{display:flex;flex-wrap:wrap;justify-content:center;gap:8px}.mdf-fresh-color-choices button{position:relative;display:flex;align-items:center;gap:7px;min-height:44px;padding:8px 11px;border:1px solid #ded8ca;border-radius:6px;background:#fff;color:#25221d;-webkit-text-fill-color:#25221d;font:inherit;font-size:13px;line-height:1.2;cursor:pointer}.mdf-fresh-color-choices button[aria-pressed=true]{border-color:#9b8149;background:#f7f2e7;box-shadow:inset 0 0 0 1px #9b8149}.mdf-fresh-color-choices button:focus-visible{outline:2px solid #9b8149;outline-offset:3px}.mdf-fresh-color-dot{position:relative;display:block;width:20px;height:20px;flex:0 0 20px;border-radius:50%;border:1px solid #b8afa0}.mdf-fresh-color-choices button:disabled{opacity:.48;cursor:not-allowed}.mdf-fresh-color-choices button:disabled .mdf-fresh-color-dot:after{content:"";position:absolute;left:-2px;top:9px;width:23px;height:1px;background:#333;transform:rotate(-45deg)}.mdf-fresh-color-choices small{font-size:10px}.mdf-fresh-color-status{font-size:12px!important;line-height:1.5!important;margin:9px 0 0!important;color:#716550}';
        box.appendChild(style);native.hidden=true;native.style.display='none';native.after(box);refresh();
        form.addEventListener('submit',event=>{
          const current=form.querySelector('[data-variant-id-input]')?.value;
          const primary=variants.find(v=>v.options[0]===selected[0]);
          if(!selected.length || selected.length>max || !primary?.available || String(primary.id)!==current){event.preventDefault();event.stopImmediatePropagation();refresh(!selected.length?'Please choose at least one rose color.':'Your color selection is updating. Please try again in a moment.');box.scrollIntoView({block:'center',behavior:'smooth'});buttons.find(b=>!b.disabled)?.focus();}
        },true);
      }

      _initLaVieRoseColors() {
        const native=this.querySelector('product-option-picker');
        const form=this.getParentSection()?.querySelector('product-form form');
        if(!native || !form || this.optionsData.length!==1 || this.querySelector('[data-fresh-colors]'))return;
        // Existing La Vie inventory units: never substitute a solid variant for a mix.
        const mappings=[
          {id:50949599199547,colors:['Red']},
          {id:50949599232315,colors:['White']},
          {id:50949599265083,colors:['Pink']},
          {id:50954013081915,colors:['Red','White']},
          {id:50954013147451,colors:['Red','Pink']},
          {id:50954013180219,colors:['White','Pink']}
        ];
        const entries=mappings.map(mapping=>({...mapping,variant:this.variantsData.find(v=>String(v.id)===String(mapping.id))}));
        const initial=entries.find(entry=>String(entry.id)===String(this.variant?.id));
        // Leave the native picker intact if the catalog no longer matches this mapping.
        if(entries.some(entry=>!entry.variant) || !initial)return;
        const palette={Red:'#ad1530',White:'#f7f3e9',Pink:'#e9a4b8'};
        let selected=[...initial.colors];
        const selectedEntry=()=>entries.find(entry=>entry.colors.length===selected.length && entry.colors.every(color=>selected.includes(color)));
        const box=document.createElement('fieldset');box.dataset.freshColors='';box.className='mdf-fresh-colors';
        const legend=document.createElement('legend');legend.textContent='Choose up to 2 colors';box.appendChild(legend);
        const choices=document.createElement('div');choices.className='mdf-fresh-color-choices';box.appendChild(choices);
        const status=document.createElement('p');status.className='mdf-fresh-color-status';status.setAttribute('aria-live','polite');box.appendChild(status);
        const property=document.createElement('input');property.type='hidden';property.name='properties[Rose Colors]';property.dataset.freshColorProperty='';form.querySelector('[data-fresh-color-property]')?.remove();form.appendChild(property);
        const buttons=[];
        const refresh=(message)=>{
          property.value=selected.join(', ');property.disabled=!selected.length;
          buttons.forEach(button=>button.setAttribute('aria-pressed',String(selected.includes(button.dataset.color))));
          const entry=selectedEntry();
          status.textContent=message || (!selected.length?'Please choose at least one rose color.':!entry?.variant.available?'This color combination is sold out. Please choose another.':'');
          status.hidden=!status.textContent;
        };
        const syncVariant=()=>{
          const entry=selectedEntry();if(!entry)return;
          const value=entry.variant.options[0];
          const input=Array.from(native.querySelectorAll('input,select')).find(el=>el.name===this.optionsData[0].name && (el.tagName==='SELECT'||el.value===value));
          if(input){if(input.tagName==='SELECT')input.value=value;else input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}
        };
        for(const [name,color] of Object.entries(palette)){
          const button=document.createElement('button');button.type='button';button.dataset.color=name;button.setAttribute('aria-label',name);
          // A sold-out single can still form an available mix: availability belongs to the complete combination.
          const dot=document.createElement('span');dot.className='mdf-fresh-color-dot';dot.style.backgroundColor=color;dot.setAttribute('aria-hidden','true');
          const label=document.createElement('span');label.textContent=name;button.append(dot,label);
          button.addEventListener('click',()=>{
            if(selected.includes(name))selected=selected.filter(color=>color!==name);
            else if(selected.length<2)selected.push(name);
            else {refresh('Choose up to 2 colors. Deselect one to change your palette.');return;}
            refresh();syncVariant();
          });buttons.push(button);choices.appendChild(button);
        }
        const style=document.createElement('style');style.textContent='.mdf-fresh-colors{border:0;padding:0;margin:0 0 20px;min-width:0;width:100%;text-align:center}.mdf-fresh-colors legend{width:100%;text-align:center;font-family:inherit;font-weight:700;font-size:15px;line-height:1.4;color:#27231e;margin-bottom:12px;padding:0}.mdf-fresh-color-choices{display:flex;flex-wrap:wrap;justify-content:center;gap:8px}.mdf-fresh-color-choices button{position:relative;display:flex;align-items:center;gap:7px;min-height:44px;padding:8px 11px;border:1px solid #ded8ca;border-radius:6px;background:#fff;color:#25221d;-webkit-text-fill-color:#25221d;font:inherit;font-size:13px;line-height:1.2;cursor:pointer}.mdf-fresh-color-choices button[aria-pressed=true]{border-color:#9b8149;background:#f7f2e7;box-shadow:inset 0 0 0 1px #9b8149}.mdf-fresh-color-choices button:focus-visible{outline:2px solid #9b8149;outline-offset:3px}.mdf-fresh-color-dot{position:relative;display:block;width:20px;height:20px;flex:0 0 20px;border-radius:50%;border:1px solid #b8afa0}.mdf-fresh-color-choices button:disabled{opacity:.48;cursor:not-allowed}.mdf-fresh-color-choices button:disabled .mdf-fresh-color-dot:after{content:"";position:absolute;left:-2px;top:9px;width:23px;height:1px;background:#333;transform:rotate(-45deg)}.mdf-fresh-color-choices small{font-size:10px}.mdf-fresh-color-status{font-size:12px!important;line-height:1.5!important;margin:9px 0 0!important;color:#716550}';
        box.appendChild(style);native.hidden=true;native.style.display='none';native.after(box);refresh();
        form.addEventListener('submit',event=>{
          const entry=selectedEntry();
          const current=form.querySelector('[data-variant-id-input]')?.value;
          if(!entry?.variant.available || String(entry.id)!==current || this.hasAttribute('aria-busy')){
            event.preventDefault();event.stopImmediatePropagation();
            refresh(!selected.length?'Please choose at least one rose color.':!entry?.variant.available?'This color combination is sold out. Please choose another.':'Your color selection is updating. Please try again in a moment.');
            box.scrollIntoView({block:'center',behavior:'smooth'});buttons[0]?.focus();
          }
        },true);
      }

      _getDefaultVariant() {
        this.variant = this.variantsData.find(v => v.id === +this.getAttribute('current-variant-id')) || this.variantsData.find(v=>v.available) || this.variantsData[0];
      };

      _setInititalCache() {
        const parentSection = this.getParentSection();
        if(this.variant && parentSection)this.cache[this.variant.id] = {html:parentSection.outerHTML,at:Date.now()};
      };
  
      _checkUnavailable() {
        if(!this.variant)return;
        this.optionsData.map((option, i) => {
          let optionsToCheck = [...this.variant.options];
          option.values.map(optionValue => {
            optionsToCheck[i] = optionValue;
            const match = this._findVariantByOptions(optionsToCheck);
            this._toggleOption(option.name, optionValue, !match);   
          })
        })
      };
  
      _toggleOption(name, value, disable) {
        const inputs=Array.from(this.querySelectorAll('input,select')).filter(el=>el.name===name);
        for(const input of inputs){
          const targets=input.tagName==='SELECT'?Array.from(input.options).filter(option=>option.value===value):input.value===value?[input]:[];
          targets.forEach(target=>target.toggleAttribute('data-unavailable',disable));
        }
      };
  
      _variantChangeHandler(e) {
        if (!e.detail?.synthetic && this.optionsData.some(option=>option.name===e.target.name)) {
            const requestId = this.variantRequestId = (this.variantRequestId || 0) + 1;
            if(!this._selectVariantByOption(e.target))return;
            this.variantController?.abort();
            const { queryURL, currentURL } = updateURLParams({ 'variant': this.variant.id }, this.sectionId, window.location.origin + this.getAttribute('product-url'));
            if (this.isProductPage) historyPush(currentURL);
            this._checkUnavailable();

            this._beginVariantRequest();
            const cached = this.cache[this.variant.id];
            // console.log(cached);
            // console.log(this.cache);

            if (cached && Date.now()-cached.at<15000) {
              this.forwardEvent('variantChange', {
                  html: parseHTML(cached.html),
                  variant: this.variant
              });
              this._completeVariantRequest();
            } else {
              this._fetchPageWithVariant(queryURL, (html) => {
                if (requestId !== this.variantRequestId) return;
                this.cache[this.variant.id] = {html,at:Date.now()};
                this.forwardEvent('variantChange', {
                        html: parseHTML(html),
                        variant: this.variant
                    });
                this._completeVariantRequest();
                }).catch(() => { if (requestId === this.variantRequestId) this._failVariantRequest(currentURL); });
            }
            
        }  
      };
  
      _beginVariantRequest() {
        const section=this.getParentSection();
        this.querySelector('[data-variant-error]')?.remove();
        if(!this.purchaseState){
          this.purchaseState=[...section.querySelectorAll('[data-add-button]')].map(button=>({button,disabled:button.disabled}));
          this.expressState=[...section.querySelectorAll('[data-buy-button]')].map(node=>({node,hidden:node.hidden}));
        }
        this.purchaseState.forEach(({button})=>button.disabled=true);
        this.expressState.forEach(({node})=>node.hidden=true);
        this.setAttribute('aria-busy','true');
      }
      _completeVariantRequest() {
        this.purchaseState?.forEach(({button,disabled})=>button.disabled=disabled);
        this.expressState?.forEach(({node,hidden})=>node.hidden=hidden || !this.variant.available);
        this.purchaseState=null;this.expressState=null;
        this.removeAttribute('aria-busy');
      }
      _failVariantRequest(url) {
        this.removeAttribute('aria-busy');
        this.forwardEvent('variantLoadError');
        const message=document.createElement('p');message.setAttribute('role','alert');message.setAttribute('data-variant-error','');
        message.textContent='This option could not be loaded. Choose another option or ';
        const retry=document.createElement('a');retry.href=url;retry.textContent='reload this selection';message.appendChild(retry);
        this.appendChild(message);
      }
      _selectVariantByOption(target) {
        const index=this.optionsData.findIndex(option=>option.name===target.name);
        if(index<0 || !this.variant)return false;
        const options=[...this.variant.options];options[index]=target.value;
        const chosen=this._findVariantByOptions(options) || this.variantsData.find(variant=>variant.options[index]===target.value && variant.available) || this.variantsData.find(variant=>variant.options[index]===target.value);
        if(!chosen){this._toogleInputs(target);return false;}
        this.variant=chosen;this._toogleInputs(target);return true;
      }
      _toogleInputs() {
        this.variant.options.forEach((value,index)=>{
          const name=this.optionsData[index].name;
          Array.from(this.querySelectorAll('input,select')).filter(input=>input.name===name).forEach(input=>{
            if(input.tagName==='SELECT')input.value=value;
            else input.checked=input.value===value;
            if(input.tagName==='SELECT' || input.checked)input.dispatchEvent(new CustomEvent('change',{bubbles:true,detail:{synthetic:true}}));
          });
        });
      }
      _findVariantByOptions(options) {
        return this.variantsData.find(variant => isEqual(variant.options, options));
      };
  
      _updateSwatchLable(swatchInput) {
        swatchInput.closest('product-variant-swatch').querySelector('[data-swatch-value]').textContent = swatchInput.value;
      };
  
      _fetchPageWithVariant(url, onResponse) {
        this.forwardEvent('variantLoading');
        this.variantController?.abort();this.variantController=new AbortController();
        return fetch(url,{signal:this.variantController.signal})
        .then(response => { if (!response.ok) throw new Error('Variant unavailable'); return response.text(); })
        .then(responseText => {
          onResponse(responseText);
        });
      };
      disconnectedCallback(){super.disconnectedCallback();this.variantController?.abort();this.variantRequestId=(this.variantRequestId||0)+1;}
    });

    customElements.define('product-option-picker', class extends baseComponent.default {
        elements = {
            value: '[data-option-value]'
        }
        render() {
            this.addEventListener('change', e => {
                if(this.$value) {
                    this.$value.innerText = e.target.dataset.optionLabel || e.target.value;
                }
            })
        }
    })
  })();


